// This search bar is specifically for approval assignment in approvals history.
// since we had only two styling needed, so preferred inline styling over here.
import React from 'react';
import PropTypes from 'prop-types';
import './search-bar.css';

const SearchBar = ({ searchHandler, value }) => {
  const dummy = 'null';
  console.log('had to do, to make it work', dummy);

  return (
    <div className="Search">
      <input
        className="Search-Input"
        // style={{ width: '390px' }}
        type="text"
        onChange={(e) => searchHandler(e.target.value)}
        placeholder=" Please Search Here"
        value={value}
      />
    </div>
  );
};

SearchBar.propTypes = {
  searchHandler: PropTypes.func,
  // placeholder: PropTypes.string,
  value: PropTypes.string,
};

export {
  SearchBar,
};
